import { Inbox } from "lucide-react";

export default function EmptyState({ title = "No data yet", subtitle, action, testId = "empty-state" }) {
  return (
    <div className="py-16 text-center" data-testid={testId}>
      <div
        className="w-14 h-14 mx-auto rounded-full flex items-center justify-center mb-4"
        style={{ background: "#f1f2f4", color: "var(--brand-muted)" }}
      >
        <Inbox size={22} />
      </div>
      <h3 className="text-base font-medium" style={{ color: "var(--brand-navy)" }}>
        {title}
      </h3>
      {subtitle && (
        <p className="mt-1 text-sm" style={{ color: "var(--brand-muted)" }}>
          {subtitle}
        </p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
